import React, { FC } from "react";
import SlidingIconButton from "./SlidingIconButton";
import { useStore } from "../../store/store";

const HelpButton: FC = () => {
  const { isTourOpen, setTourOpen } = useStore();
  const onClick = () => {
    if (isTourOpen) {
      setTourOpen(false);
    } else {
      setTourOpen(true);
    }
  };
  return (
    <SlidingIconButton
      color="text-white"
      text="Help"
      iconClass="d-question-mark"
      className="hover:w-[5rem] hover:border-sunshineYellow"
      onClick={onClick}
      openByDefault={false}
      reverse={true}
      reverseAnimation={false}
    />
  );
};

export default HelpButton;
